import React from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Legend,
  Tooltip
} from 'recharts';
import config from '../../config';
import { getDayMonthDateYear, getMonthDateYear } from '../../utils';
import { formatProgressData } from './linePlotHelpers';

export default function LinePlot({ data, selectData, selectedDataKeyMap }) {
  formatProgressData({ data });
  return (
    <ResponsiveContainer>
      <LineChart
        margin={{ top: 0, left: 25, right: 0, bottom: 50 }}
        data={data}
      >
        <CartesianGrid stroke='#e5e7e9' />
        {Object.keys(selectedDataKeyMap).map((key) =>
          selectData.includes(selectedDataKeyMap[key]) ? (
            <Line
              isAnimationActive={false}
              key={key}
              name={key}
              dataKey={key}
              stroke={config.plots.line.colors[key]}
              strokeWidth={2}
            />
          ) : null
        )}
        <XAxis
          dataKey='Date'
          type='number'
          scale='time'
          interval={1}
          textAnchor='end'
          domain={['dataMin', 'dataMax']}
          tick={{ angle: -35 }}
          tickFormatter={getMonthDateYear}
          label={{
            value: 'Date',
            dy: 50,
            fontSize: 16,
            fontWeight: 'bold'
          }}
        />
        <YAxis
          label={{
            value: 'Count',
            dx: -35,
            angle: -90,
            fontSize: 16,
            fontWeight: 'bold'
          }}
        />
        <Legend
          layout='vertical'
          verticalAlign='middle'
          align='right'
          wrapperStyle={{ paddingLeft: 10 }}
        />
        <Tooltip labelFormatter={getDayMonthDateYear} />
      </LineChart>
    </ResponsiveContainer>
  );
}
